import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(document).ready(function () {
    const media = gsap.matchMedia();

    media.add(
        "(min-width: 992px) and (prefers-reduced-motion: no-preference)",
        function () {
            $(".tpl-cards-slider").each(function () {
                const section = this;
                const inner = $(section).children(".inner").first().get(0);

                if (!inner) {
                    return;
                }

                const wrapper = $(inner).children(".wrapper").first().get(0);
                const slides = wrapper ? $(wrapper).children(".slide") : $();

                if (!wrapper || slides.length === 0) {
                    return;
                }

                const travel = function () {
                    const last = slides.get(slides.length - 1);
                    const padding =
                        parseFloat($(wrapper).css("padding-right")) || 0;
                    const content = last.offsetLeft + last.offsetWidth + padding;

                    return Math.max(1, content - inner.clientWidth);
                };

                gsap.to(wrapper, {
                    x: function () {
                        return -travel();
                    },
                    ease: "none",
                    scrollTrigger: {
                        trigger: section,
                        start: function () {
                            return `top top+=${$.constants.menuHeight}`;
                        },
                        end: function () {
                            return `+=${travel()}`;
                        },
                        pin: inner,
                        scrub: true,
                        anticipatePin: 1,
                        invalidateOnRefresh: true,
                        refreshPriority: $.refreshPriority(section),
                    },
                });
            });
        }
    );
});
